import * as React from "react";

export function DecodableLogoSmall(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      {...props}
    >
      <path
        fill="#06091A"
        d="M0 87.137v-20.06c6.21 0 12.167-2.466 16.559-6.856a23.4 23.4 0 0 0 0-33.1A23.424 23.424 0 0 0 0 20.265V.202a43.503 43.503 0 0 1 30.498 12.87 43.458 43.458 0 0 1 12.599 30.597 43.458 43.458 0 0 1-12.6 30.598A43.503 43.503 0 0 1 0 87.137ZM84.777 87.137l-27.515-27.5a22.586 22.586 0 0 1 0-31.916L84.777.216 100 15.432 71.731 43.686 100 71.936 84.777 87.137Z"
      />
    </svg>
  );
}
